/* istanbul ignore file */
const styles = ({
  palette: {
    grey: { G100 }
  },
  spacing: { unit }
}) => ({
  greyBg: {
    display: 'inline-block',
    position: 'relative',
    background: G100,
    marginBottom: unit * 2,
    width: '100%'
  },
  greyContent: {
    '& .create-payment__top-section': {
      display: 'flex',

      '& .dropdown label': {
        display: 'block'
      },

      '& label': {
        display: 'block',

        '&:after': {
          float: 'right'
        }
      },

      '& .create-payment__top-section__rows': {
        flex: 1,
        padding: [3 * unit, 7.5 * unit],

        '& .datepicker input': {
          width: '100%'
        },

        '& .col-xs-2': {
          minWidth: 200
        },
        '& .flex-dropdown > div': {
          padding: `0 ${unit * 2}px`
        },
        '& .create-payment__top-section__row': {
          display: 'flex',
          '& .optional': {
            '& label': {
              display: 'flex'
            }
          }
        }
      }
    },
    '& .initiate-row': {
      display: 'inline-block',
      width: '100%',
      paddingLeft: unit * 5
    }
  },
  apiError: {
    margin: `${unit * 3}px 0 0 ${unit * 5}px`,
    width: `calc(100% - ${unit * 5}px)`
  },
  formEl: {
    display: 'inline-block',
    width: '100%'
  },

  formGroup: {
    display: 'inline-block',
    width: '100%',
    margin: `0 -${unit * 2}px`,
    '& .form-group label': {
      display: 'block'
    },
    '& .control label': {
      display: 'block'
    }
  },
  list: {
    listStyle: 'none',
    padding: 0,
    '& li': {
      display: 'flex'
    }
  },
  isFlexDrop: {
    maxWidth: '285px'
  },
  circle: {
    borderRadius: '50%',
    border: '2px solid red',
    width: `${unit * 2.25}px`,
    height: `${unit * 2.25}px`,
    display: 'inline-block',
    margin: `0 ${unit * 1.25}px 0 0`
  },
  fieldset: {
    padding: '12px 44px',
    background: G100,
    paddingTop: unit * 3.75,
    marginBottom: unit * 3.75
  },
  columnPadding: {
    background: G100,
    padding: `${unit * 3.5}px ${unit * 7.5}px`
  },
  title: {
    fontWeight: 'bold',
    paddingBottom: unit,
    color: '#757575 !important',
    textTransform: 'uppercase',
    fontSize: unit * 1.5
  },
  valueDateLarge: {
    color: '#757575',
    fontSize: unit * 2,
    paddingTop: unit / 2
  }
});

export default styles;
